<template>
    <section>
        <div class="content">
            <div class="card card-default">
                <div class="card-header">
                    <h3 class="card-title">
                        <span>
                            <strong><i class="fa-solid fa-magnifying-glass"></i> {{ $t('labels.search') }}</strong>
                        </span>
                    </h3>
                    <div class="card-tools">
                        <button type="button" class="btn btn-tool" data-card-widget="collapse"
                            v-bind:title="$t('labels.collapse')">
                            <i class="fas fa-minus"></i>
                        </button>
                    </div>
                </div>
                <!-- SEARCH CONTENT INPUT-->
                <div class="card-body">
                    <div class="row mb-2 row-cols-1 row-cols-sm-1 row-cols-md-5 row-cols-lg-5 row-cols-xl-5">
                        <div class="col mb-3">
                            <TheSelect id="" title="Số dòng" :options="pageOptions" :initialValue="pageSize.toString()"
                                @onChange="(v) => onChangePageOptions(v)" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Loại thống kê" :options="category_LOAITHONGKE_THOIGIAN"
                                :initialValue="modelRec.sREC_LOAITHONGKE" :model="modelRec.sREC_LOAITHONGKE"
                                :isMultiple="false" :isAllowClear="true" :isRequire="true"
                                @onChange="(e) => onChangeLoaiThongKe(e)" :key="tempKey" />
                        </div>
                        <div class="col mb-3" v-if="modelRec.sREC_LOAITHONGKE == 2">
                            <TheSelect title="Tháng" :options="category_THANG" :initialValue="modelRec.sREC_THANG"
                                :isMultiple="false" :isAllowClear="true" :isRequire="false"
                                @onChange="(e) => modelRec.sREC_THANG = e" :key="tempKey" />
                        </div>
                        <div class="col mb-3" v-if="modelRec.sREC_LOAITHONGKE == 1">
                            <TheSelect title="Quý" :options="category_QUY" :initialValue="modelRec.sREC_QUY"
                                :isMultiple="false" :isAllowClear="true" :isRequire="false"
                                @onChange="(e) => modelRec.sREC_QUY = e" :key="tempKey" />
                        </div>
                        <div v-if="modelRec.sREC_LOAITHONGKE != 3 && modelRec.sREC_LOAITHONGKE" class="col mb-3">
                            <div class="form-group">
                                <label>Thống kê theo năm</label>
                                <VueDatePicker v-model="modelRec.sREC_NAM" :enable-time-picker="false" placeholder="Năm"
                                    format="yyyy" auto-apply :close-on-auto-apply="true" year-picker
                                    :year-range="[2023, new Date().getFullYear()]" />
                            </div>
                        </div>
                        <div class="col mb-3" v-if="modelRec.sREC_LOAITHONGKE == 3">
                            <TheDateRangePicker title="Theo ngày" placeholder="Thống kê theo ngày" :isReadonly="false"
                                :isRequire="false" :key="tempKey" :isTextInput="false"
                                @onChangeDate="(d) => onSearchTheoNgay(d)" />
                        </div>

                        <div class="col mb-3 search-button">

                            <button type="button" class="btn btn-block bg-gradient-info mt-3 ml-2 mr-2"
                                @click="getData()"><i class="fas fa-search"></i> Tìm kiếm</button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </section>
    <section v-if="isSearch">
        <div class="content">
            <div class="card card-primary card-outline">
                <div class="card-header">
                    <h3 class="card-title">
                    </h3>
                    <div class="card-tools">
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive p-0">
                        <loading :active="isBusy" class="text-center" color="#000000" loader="spinner"></loading>
                        <table class="table table-hover" id="table">
                            <thead>
                                <tr>
                                    <th class="col10"></th>
                                    <th class="col50" v-if="modelRec.sREC_LOAITHONGKE == 3">Ngày</th>
                                    <th class="col50" v-if="modelRec.sREC_LOAITHONGKE == 2">Tháng</th>
                                    <th class="col50" v-if="modelRec.sREC_LOAITHONGKE == 1">Quý</th>
                                    <th class="col50" v-if="modelRec.sREC_LOAITHONGKE == 0">Năm</th>
                                    <th class="col50">Số lượng</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in items" :key="item.id">
                                    <td></td>
                                    <td v-if="modelRec.sREC_LOAITHONGKE == 3">{{ item.ngay }}</td>
                                    <td v-if="modelRec.sREC_LOAITHONGKE == 2">{{ item.thang }}</td>
                                    <td v-if="modelRec.sREC_LOAITHONGKE == 1">{{ item.quy }}</td>
                                    <td v-if="modelRec.sREC_LOAITHONGKE == 0">{{ item.nam }}</td>
                                    <td>{{ item.soLuong }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>

                <div class="card-footer clearfix">
                    <div class="row">
                        <div class="col-md-6">
                            <div v-if="totalRow != 0">Hiển thị {{ numberOfShow }} trên tổng số {{ totalRow }} dòng
                            </div>
                            <div v-else>Không có dữ liệu</div>
                        </div>
                        <div class="col-md-6">
                            <div class="float-right">
                                <ul class="pagination pagination-rounded">
                                    <paginate :page-count="pageCount" v-model="pageNumber" :page-range="3"
                                        :margin-pages="2" style="cursor: pointer;" :click-handler="handlePageChange"
                                        :prev-text="'Trở lại'" :next-text="'Kế đến'" :container-class="'pagination'"
                                        :page-class="'page-item'">
                                    </paginate>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </section>


</template>
<script>
import $ from 'jquery'
import { mapActions } from 'vuex'
import config from '@/config/prod.env';
import Paginate from "vuejs-paginate-next";
import Loading from "vue3-loading-overlay";
import moment from "moment"
import { common } from '@/helper/common';
import { thongKeLichSuDangNhapModel } from '@/models/quantri/thongKeLichSuDangNhap.model';
import TheSelect from '@/components/shareComponents/TheSelect.vue';
import TheDateRangePicker from '@/components/shareComponents/TheDateRangePicker.vue';


export default {
    name: "TheThongKeLichSuDangNhapQT",
    components: {
        paginate: Paginate,
        loading: Loading,
        TheSelect,
        TheDateRangePicker,
    },
    data() {
        return {
            header: '',
            isBusy: false,
            filter: null,
            items: [],

            pageNumber: config.CURRENT_PAGE,
            pageSize: config.DEFAULT_LIMIT,
            pageOptions: config.PAGE_OPTION,

            totalRow: 0,
            pageCount: 0,
            sortBy: null,
            orderDesc: true,
            numberOfShow: 0,
            title: null,
            code: null,
            styleButton: null,
            styleTitle: null,
            isReadonly: null,
            isSearch: false,
            modelRec: {
                sREC_LOAITHONGKE: null,
                sREC_TUNGAY: null,
                sREC_DENNGAY: null,
                sREC_THANG: null,
                sREC_QUY: null,
                sREC_NAM: null,
            },

            category_LOAITHONGKE_THOIGIAN: config.LOAITHONGKE_THOIGIAN,
            category_THANG: config.LOAITHONGKE_THOIGIAN_THANG,
            category_QUY: config.LOAITHONGKE_THOIGIAN_QUY,

            cEnable_Value: null,
            checkEnable_Memo: false,



            tempKey: common.randomString(10)
        }
    },
    methods: {
        ...mapActions('header', ['setupHeader',]),
        ...mapActions('alert', ['warning',]),
        ...mapActions('thongKeLichSuDangNhapQT', ['getPagingThongKeLichSuDangNhapQT_TheoNgay', 'getPagingThongKeLichSuDangNhapQT_TheoThang', 'getPagingThongKeLichSuDangNhapQT_TheoQuy', 'getPagingThongKeLichSuDangNhapQT_TheoNam']),

        async setup() {
            let header = 'Thống kê lịch sử đăng nhập'
            this.setupHeader({ header })
        },

        async initialize() {
        },



        async handleSortChange(sortCol) {
            if (this.sortBy == sortCol) {
                if (this.orderDesc == true) {
                    this.sortBy = sortCol
                    this.orderDesc = false
                    this.sValue_SORT = sortCol + (this.orderDesc == true ? " desc" : " asc")
                }
                else if (this.orderDesc == false) {
                    this.orderDesc = null
                    this.sortBy = null
                    this.sValue_SORT = null
                }
            }
            else {
                this.sortBy = sortCol
                this.orderDesc = true
                this.sValue_SORT = sortCol + (this.orderDesc == true ? " desc" : " asc")
            }
        },
        async handlePageChange(page) {
            this.pageNumber = page
            await this.getData()
        },
        async onChangePageOptions(pageSize) {
            this.pageSize = pageSize
            await this.handlePageChange(1)
        },

        async onChangeLoaiThongKe(e) {
            this.modelRec = {
                sREC_LOAITHONGKE: null,
                sREC_TUNGAY: null,
                sREC_DENNGAY: null,
                sREC_THANG: null,
                sREC_QUY: null,
                sREC_NAM: null,
            }
            this.modelRec.sREC_LOAITHONGKE = e
            this.isSearch = false
        },

        async isDate(value) {
            return value instanceof Date && !isNaN(value);
        },
        async fromDatetoString(input) {
            let day = null
            let month = null

            if (input.getUTCDate() >= 10) {
                day = "" + (input.getUTCDate())
            }
            else {
                day = "0" + (input.getUTCDate())
            }

            if (input.getUTCMonth() + 1 >= 10) {
                month = "" + (input.getUTCMonth() + 1)
            }
            else {
                month = "0" + (input.getUTCMonth() + 1)
            }
            return day + "/" + month + "/" + input.getUTCFullYear();
        },
        fromStringtoDate(dString) {
            var newDateTime = moment(dString, "DD/MM/YYYY").toDate();
            return newDateTime != 'Invalid Date' ? newDateTime : null;
        },

        async onSearchTheoNgay(e) {
            if (e) {
                if (!(await this.isDate(e.at(0))) || !(await this.isDate(e.at(1)))) {
                    this.$store.dispatch("alert/error", "Ngày không phù hợp", { root: true });
                    this.modelRec.sREC_TUNGAY = null
                    this.modelRec.sREC_DENNGAY = null
                }
                else {
                    this.modelRec.sREC_TUNGAY = e.at(0) ? await this.fromDatetoString(e.at(0)) : null
                    this.modelRec.sREC_DENNGAY = e.at(1) ? await this.fromDatetoString(e.at(1)) : null
                }

            }
            else {
                this.modelRec.sREC_TUNGAY = null
                this.modelRec.sREC_DENNGAY = null
            }
        },
        async onSearchKey() {
            this.pageNumber = config.CURRENT_PAGE
        },


        async getData() {
            if (this.modelRec.sREC_LOAITHONGKE) {
                this.isBusy = true
                this.csList = []
                let params = {
                    pageNumber: this.pageNumber,
                    pageSize: this.pageSize,
                    sort: this.sValue_SORT,
                }
                if (this.modelRec.sREC_LOAITHONGKE == 0) {
                    params.nam = this.modelRec.sREC_NAM == "" ? null : this.modelRec.sREC_NAM
                    await this.getPagingThongKeLichSuDangNhapQT_TheoNam({ params: params }).then(res => {
                        if (res) {
                            // List data
                            this.isSearch = true
                            this.items = res.data ? res.data : []

                            // // Total row
                            this.totalRow = res.totalRow
                            // // Number show
                            this.numberOfShow = !this.items ? 0 : ((this.pageNumber - 1) * this.pageSize) + this.items.length;
                            // // Total number page
                            this.pageCount = parseInt(((this.totalRow - 1) / this.pageSize)) + 1;
                        }
                        else {
                            this.isSearch = true
                            this.items = []
                        }

                    });
                    this.isBusy = false;

                }
                else if (this.modelRec.sREC_LOAITHONGKE == 1) {
                    params.quy = this.modelRec.sREC_QUY == "" ? null : this.modelRec.sREC_QUY
                    params.nam = this.modelRec.sREC_NAM == "" ? null : this.modelRec.sREC_NAM
                    await this.getPagingThongKeLichSuDangNhapQT_TheoQuy({ params: params }).then(res => {
                        if (res) {
                            // List data
                            this.isSearch = true
                            this.items = res.data ? res.data : []

                            // // Total row
                            this.totalRow = res.totalRow
                            // // Number show
                            this.numberOfShow = !this.items ? 0 : ((this.pageNumber - 1) * this.pageSize) + this.items.length;
                            // // Total number page
                            this.pageCount = parseInt(((this.totalRow - 1) / this.pageSize)) + 1;
                        }
                        else {
                            this.isSearch = true
                            this.items = []
                        }
                    });
                    this.isBusy = false;

                }
                else if (this.modelRec.sREC_LOAITHONGKE == 2) {
                    params.thang = this.modelRec.sREC_THANG == "" ? null : this.modelRec.sREC_THANG
                    params.nam = this.modelRec.sREC_NAM == "" ? null : this.modelRec.sREC_NAM
                    await this.getPagingThongKeLichSuDangNhapQT_TheoThang({ params: params }).then(res => {
                        if (res) {
                            // List data
                            this.isSearch = true
                            this.items = res.data ? res.data : []

                            // // Total row
                            this.totalRow = res.totalRow
                            // // Number show
                            this.numberOfShow = !this.items ? 0 : ((this.pageNumber - 1) * this.pageSize) + this.items.length;
                            // // Total number page
                            this.pageCount = parseInt(((this.totalRow - 1) / this.pageSize)) + 1;
                        }
                        else {
                            this.isSearch = true
                            this.items = []
                        }
                    });
                    this.isBusy = false;

                }
                else if (this.modelRec.sREC_LOAITHONGKE == 3) {
                    params.tuNgay = this.modelRec.sREC_TUNGAY
                    params.denNgay = this.modelRec.sREC_DENNGAY
                    await this.getPagingThongKeLichSuDangNhapQT_TheoNgay({ params: params }).then(res => {
                        if (res) {
                            // List data
                            this.isSearch = true
                            this.items = res.data ? res.data : []

                            // // Total row
                            this.totalRow = res.totalRow
                            // // Number show
                            this.numberOfShow = !this.items ? 0 : ((this.pageNumber - 1) * this.pageSize) + this.items.length;
                            // // Total number page
                            this.pageCount = parseInt(((this.totalRow - 1) / this.pageSize)) + 1;
                        }
                        else {
                            this.isSearch = true
                            this.items = []
                        }
                    });
                    this.isBusy = false;
                }
            }
            else {
                this.$store.dispatch("alert/error", "Bắt buộc phải chọn loại thống kê", { root: true });
            }

        },
    },

    async mounted() {
        await this.initialize()
        await this.setup()
        //await this.getData()

    }


}
</script>
<style>
.search-button {
    display: flex;
    justify-content: center;
    /* căn giữa theo chiều ngang */
    align-items: center;
    /* căn giữa theo chiều dọc */

}
</style>